import firebase from "firebase/compat/app";
import "firebase/compat/analytics";
import "firebase/compat/storage";

var firebaseConfig = {
    apiKey: "AIzaSyBK7-eetlMvbDRRRtIN1wvFCHO8Eh0KWGI",
    authDomain: "horsey-resume.firebaseapp.com",
    projectId: "horsey-resume",
    storageBucket: "horsey-resume.appspot.com",
    messagingSenderId: "148689830495",
    appId: "1:148689830495:web:2d6598f813e1728665d1ea",
    measurementId: "G-8TX0YV9PEB"
  };
  // Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

var storageRef = firebase.storage().ref();